<template>
  <sp-360-panel
    :image="image"
    :title="title"
    :footerText="footerText"
    :footerComplementar="footerComplementar"
    v-bind:justifyVertically="justifyVertically"
    v-bind:enableTooltipOverflowX="enableTooltipOverflowX"
  >
  <div>
    <slot/>
  </div>
  </sp-360-panel>
</template>

<script>
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'sp360-list',
  components: { Sp360Panel },
  props: {
    fit: Boolean,
    image: String,
    title: String,
    footerText: { type: String, default: null },
    footerComplementar: { type: String, default: null },
    justifyVertically: { type: Boolean, default: false },
    enableTooltipOverflowX: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss">
@import "~vuestic-ui/src/components/vuestic-sass/resources/resources";

</style>
